import { EnumBase } from 'hay-core-react';
class UsuarioPinTipoEnvioEnum extends EnumBase {
    constructor() {
        super([
            'main.usuariopin.tipoenvio.email',
            'main.usuariopin.tipoenvio.sms',
        ]);
    }
}

const instance = new UsuarioPinTipoEnvioEnum();
export default instance;
